import axiosInstance from '@/utils/axiosInstance';
import { getAuthHeaders } from '@/utils/api.js';
import { API_URL, USER_ROLES } from '../../../constant/constant';

export const createAddress = async (addressData, userId) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL.BASE_VENDOR}/rest/big-local/api/v1/address`,
      addressData,
      {
        headers: {
          ...getAuthHeaders(),
          'X-Vendor-Id': userId,
          'X-USER-ROLE': USER_ROLES.VENDOR,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating address:', error);
    throw error;
  }
};
